import ApiClient, {requestRemoteData} from '../../API/api';
import HttpRequestError from '../../API/models/HttpRequestError';
import {mapRemoteData} from '../../common/domain/RemoteData.model';

const FAVORITE_ENDPOINT = 'account/favorites';
const GET_PRODUCT_ENDPOINT = 'products';

// Los favoritos son del cliente: en modo comercial, del cliente por el que se actúa.
const actingAsHeaders = (actingAsNumCliente) =>
  actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {};

export const addToFavorites = (productCode, actingAsNumCliente = null) => {
  return requestRemoteData(
    FAVORITE_ENDPOINT,
    { method: 'POST', queryParams: { cod_articulo: productCode }, headers: actingAsHeaders(actingAsNumCliente) }
  );
};

export const removeFromFavorites = (productCode, actingAsNumCliente = null) => {
  return requestRemoteData(
    FAVORITE_ENDPOINT,
    { method: 'DELETE', queryParams: { cod_articulo: productCode }, headers: actingAsHeaders(actingAsNumCliente) }
  );
};

const parseGetProduct = (response) => {
  if (response.status > 300) {
    throw new HttpRequestError('Failed to get product', JSON.stringify(response));
  }
  return response;
};

export const fetchProduct = (productCode, actingAsNumCliente = null) => {
  const headers = actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {};
  return requestRemoteData(
    GET_PRODUCT_ENDPOINT,
    { queryParams: { code: productCode }, headers }
  ).then(rd => mapRemoteData(rd, parseGetProduct));
};

/**
 * Últimas ventas del artículo al cliente por el que actúa el comercial.
 * El backend devuelve [] si no eres comercial o no hay cliente seleccionado.
 */
/** Tarifas del artículo (comerciales con permiso "Ver tarifas"); cliente suplantado opcional. */
export const fetchTarifas = (productCode, actingAsNumCliente) => {
  return ApiClient.performRequest(
    `comercial/tarifas/${encodeURIComponent(productCode)}`,
    { headers: actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {} }
  );
};

export const fetchSalesHistory = (productCode, actingAsNumCliente) => {
  return ApiClient.performRequest(
    `${GET_PRODUCT_ENDPOINT}/sales-history`,
    {
      queryParams: { code: productCode },
      headers: { 'X-Acting-As-Client': actingAsNumCliente }
    }
  );
};

export const changeFavorite = (productCode, favorite, actingAsNumCliente = null) => {
  const method = favorite ? 'DELETE' : 'POST';
  return ApiClient.performRequest(
    FAVORITE_ENDPOINT,
    { method, queryParams: { cod_articulo: productCode }, headers: actingAsHeaders(actingAsNumCliente) }
  );
};

/**
 * TODO: move to the catalog domain
 * TODO: use remoteData fetch
 * @returns {Promise<*>}
 */
export const getFavorites = (actingAsNumCliente = null) => {
  return ApiClient.performRequest(FAVORITE_ENDPOINT, { headers: actingAsHeaders(actingAsNumCliente) });
};
